import { toast } from "react-toastify";
import { privateAxios } from "../../../config/apiConfig";
import { ACCEPT_ORDERS_FAILURE, ACCEPT_ORDERS_REQUEST, CANCELED_ORDER_FAILURE, CANCELED_ORDER_REQUEST, CHANGE_ORDER_DELIVERY_DATE_FAILURE, CHANGE_ORDER_DELIVERY_DATE_REQUEST, DELIVERED_ORDER_FAILURE, DELIVERED_ORDER_REQUEST, GET_NEW_ORDERS_FAILURE, GET_NEW_ORDERS_REQUEST, GET_NEW_ORDERS_SUCCESS, GET_ORDER_STATS_FAILURE, GET_ORDER_STATS_REQUEST, GET_ORDER_STATS_SUCCESS, GET_ORDERS_FAILURE, GET_ORDERS_REQUEST, GET_ORDERS_SUCCESS, PLACED_ORDER_FAILURE, PLACED_ORDER_REQUEST, SHIP_ORDER_FAILURE, SHIP_ORDER_REQUEST, GET_INCOME_FAILURE, GET_INCOME_REQUEST, GET_INCOME_SUCCESS, RETURN_PICKED_ORDER_REQUEST, RETURN_PICKED_ORDER_FAILURE, RETURN_COMPLETED_ORDER_REQUEST, RETURN_COMPLETED_ORDER_FAILURE, } from "./ActionType";


export const getOrders = () => async (dispatch) => {
    dispatch({ type: GET_ORDERS_REQUEST })
    try {
        const { data } = await privateAxios.get(`employee/orders`);
        dispatch({ type: GET_ORDERS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_ORDERS_FAILURE, payload: error.message })
    }
}

export const getOrderStats = () => async (dispatch) => {
    dispatch({ type: GET_ORDER_STATS_REQUEST })
    try {
        const { data } = await privateAxios.get(`employee/orders/stats`);
        dispatch({ type: GET_ORDER_STATS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_ORDER_STATS_FAILURE, payload: error.message })
    }
}

export const getIncome = () => async (dispatch) => {
    dispatch({ type: GET_INCOME_REQUEST })
    try {
        const { data } = await privateAxios.get(`employee/income-overview`);
        dispatch({ type: GET_INCOME_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_INCOME_FAILURE, payload: error.message })
    }
}

export const getNewOrders = () => async (dispatch) => {
    dispatch({ type: GET_NEW_ORDERS_REQUEST })
    try {
        const { data } = await privateAxios.get(`employee/newOrders`);
        dispatch({ type: GET_NEW_ORDERS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_NEW_ORDERS_FAILURE, payload: error.message })
    }
}

export const acceptOrder = (orderId) => async (dispatch) => {
    dispatch({ type: ACCEPT_ORDERS_REQUEST })
    try {
        const { data } = await privateAxios.put(`employee/order/${orderId}/accept`);
        if (data.status === "SUCCESS") {
            dispatch(getNewOrders())
            dispatch(getOrders())
            if (data?.response?.orderStatus === "PENDING") {
                dispatch(placeOrder(orderId))
            } else {
                toast.success("Order Picked  Successfully !!");
            }
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response);
        }
        dispatch({ type: ACCEPT_ORDERS_FAILURE, payload: error.message })
    }
}

export const updateOrderDeliveryDate = (orderId, reqData) => async (dispatch) => {
    dispatch({ type: CHANGE_ORDER_DELIVERY_DATE_REQUEST })
    try {
        const { data } = await privateAxios.post(`employee/order/${orderId}`, reqData,
            {
                headers: {
                    "Content-Type": "application/json",  // ✅ Set JSON format
                },
            }
        );
        if (data.status === "SUCCESS") {
            // dispatch({type:CHANGE_ORDER_DELIVERY_DATE_SUCCESS,payload:data})
            dispatch(getOrders())
            toast.success("Update Delivery Date Successfully !!")
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response);
        }
        dispatch({ type: CHANGE_ORDER_DELIVERY_DATE_FAILURE, payload: error.message })
    }
}

export const shipOrder = (orderId) => async (dispatch) => {
    dispatch({ type: SHIP_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`employee/order/${orderId}/ship`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Shipped Successfully")
        } else {
            toast.error(data.response)
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: SHIP_ORDER_FAILURE, payload: error.message })
    }
}

export const deliveredOrder = (orderId) => async (dispatch) => {
    dispatch({ type: DELIVERED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`employee/order/${orderId}/deliver`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Delivered Successfully")
        } else {
            toast.error(data.response)
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: DELIVERED_ORDER_FAILURE, payload: error.message })
    }
}

export const cancelOrder = (orderId) => async (dispatch) => {
    dispatch({ type: CANCELED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`employee/order/${orderId}/cancel`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Canceled Successfully")
        } else {
            toast.error(data.response)
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: CANCELED_ORDER_FAILURE, payload: error.message })
    }
}


export const placeOrder = (orderId) => async (dispatch) => {
    dispatch({ type: PLACED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`employee/order/${orderId}/place`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Confirmed and Picked Successfully")
        } else {
            toast.error(data.response)
        }

    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: PLACED_ORDER_FAILURE, payload: error.message })
    }
}

export const returnPickedUpOrder = (orderId) => async (dispatch) => {
    dispatch({ type: RETURN_PICKED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`employee/order/${orderId}/pick`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Return Order Picked from customer Successfully !!")
        } else {
            toast.error(data.response)
        }

    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: RETURN_PICKED_ORDER_FAILURE, payload: error.message })
    }
}

export const returnCompletedOrder = (orderId) => async (dispatch) => {
    dispatch({ type: RETURN_COMPLETED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`employee/order/${orderId}/complete`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Return Process Completed Successfully")
        } else {
            toast.error(data.response)
        }

    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: RETURN_COMPLETED_ORDER_FAILURE, payload: error.message })
    }
}